import { SendPasswordLinkRequestBody } from 'apps/user/apiTypes/password'

export type TPasswordLinkTypes = SendPasswordLinkRequestBody['type']
export type TBasePasswordLinkTypes = Extract<TPasswordLinkTypes, 'login_link' | 'reset_password'>

export enum IApplication {
  CarrierApp = 'carrier_app',
  ShipperApp = 'shipper_app',
  Marketplace = 'marketplace',
}
